import React, { useContext } from 'react'
import FontContext from '../context/fontsize/fontContext'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'

const useStyles = makeStyles((theme) => ({
	btn: {
		borderRadius: 30,
		borderColor: theme.palette.common.accent,
		color: theme.palette.common.accent,
		fontWeight: 500,
	},
	subtitle: {
		color: 'rgba(117, 117, 117, 1)',
	},
	darksubtitle: {
		color: 'rgba(190, 190, 190, 1)',
	},
	subtitleTwo: {
		color: 'rgba(117, 117, 117, 1)',
		paddingTop: '.5em',
		paddingBottom: '2em',
		lineHeight: '1.2rem',
	},
	darksubtitleTwo: {
		color: 'rgba(190, 190, 190, 1)',
		paddingTop: '.5em',
		paddingBottom: '2em',
		lineHeight: '1.2rem',
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500],
	},
}))
const FollowNewsletter = () => {
	const classes = useStyles()
	const theme = useTheme()
	const fontContext = useContext(FontContext)
	const { newsletterOpen, setNewsletterOpen, darkMode } = fontContext

	const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))
	const matchesXS = useMediaQuery(theme.breakpoints.down('xs'))

	const handleClickOpen = () => {
		setNewsletterOpen(true)
	}

	const handleClose = () => {
		setNewsletterOpen(false)
	}

	return (
		<>
			<Grid container>
				<Grid container>
					<Grid item xs={7}>
						<Grid container>
							<Typography variant='h5'>Don't miss out</Typography>
						</Grid>
					</Grid>
					<Grid item xs={5}>
						<Grid container justify='flex-end'>
							<Grid item>
								<Button
									variant='outlined'
									className={classes.btn}
									onClick={handleClickOpen}
								>
									Follow
								</Button>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
				<Grid container>
					<Grid item xs={9}>
						<Typography
							variant='subtitle1'
							className={darkMode ? classes.darksubtitle : classes.subtitle}
						>
							on the latest true crime
						</Typography>
					</Grid>
				</Grid>
				<Grid container>
					<Grid item xs={12}>
						<Typography
							variant='subtitle1'
							className={
								darkMode ? classes.darksubtitleTwo : classes.subtitleTwo
							}
						>
							Follow to be updated by email when a new story is released
						</Typography>
					</Grid>
				</Grid>
			</Grid>
			<Dialog
				open={newsletterOpen}
				onClose={handleClose}
				aria-labelledby='newsletter-form-dialog'
				fullScreen={fullScreen}
			>
				<form name='estimate' method='POST' netlify data-netlify='true'>
					<input type='hidden' name='form-name' value='estimate' />
					<DialogTitle
						id='newsletter-form-title'
						style={{
							marginTop: '0%',
							marginLeft: 'auto',
							marginRight: 'auto',
							color: theme.palette.common.accent,
						}}
					>
						Subscribe
						<IconButton
							aria-label='close'
							className={classes.closeButton}
							onClick={handleClose}
						>
							<CloseIcon />
						</IconButton>
					</DialogTitle>
					<DialogContent>
						<DialogContentText style={{ textAlign: 'center' }}>
							To subscribe to this website, please enter your email address
							here. We will send updates occasionally.
						</DialogContentText>
						<TextField
							margin='dense'
							id='name'
							name='email'
							label='Email Address'
							type='email'
							fullWidth
						/>
					</DialogContent>
					<DialogActions
						style={{
							marginLeft: 'auto',
							marginRight: 'auto',
							marginBottom: matchesXS ? '80%' : undefined,
						}}
					>
						<Button
							onClick={handleClose}
							size='large'
							style={{
								color: theme.palette.common.accent,
							}}
						>
							Cancel
						</Button>
						<Button
							onClick={handleClose}
							style={{ color: theme.palette.common.accent }}
							as='button'
							type='submit'
						>
							Subscribe
						</Button>
					</DialogActions>
				</form>
			</Dialog>
		</>
	)
}

export default FollowNewsletter
